import ContractFilesTab from "@/src/components/organism/ContractFilesTab";

interface ContractFilesTabProps {
  tab: "list" | "gallery";
  onTabChange: (tab: ContractFilesTabProps["tab"]) => void;
}

const ImporterContractFilesTab = ({ tab, onTabChange }: ContractFilesTabProps) => {
  return (
    <ContractFilesTab 
      tab={tab} 
      onTabChange={onTabChange}
      userType="IMPORTER"
    />
  );
};

export default ImporterContractFilesTab;
